module.exports = __webpack_public_path__ + "static/sas-8075053b61745ef83e130a928eb6b6c4.svg";